import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-1em);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const BannerWrapper = styled.section`
  color: #fff;
  height: 35vh;
  align-items: center;
  display: flex;
  padding: 6em 0 4em 0;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-bottom: 0 !important;
  cursor: default;
  position: relative;
  background-color: #242943;

  @media (min-width: 1200px) {
    height: 65vh;
  }

  .inner {
    padding: 0 !important;
    position: relative;
    z-index: 2;
    margin: 0 auto;
    max-width: 65em;
    width: calc(100% - 6em);
  }

  header {
    h1 {
      font-family: "Comfortaa", Helvetica, sans-serif;
      animation: ${slideIn} .4s ease-in-out forwards;
      font-size: 1.7em;

      @media (min-width: 1200px) {
        font-size: 2.4em;
      }

      &:after {
        content: '';
        background-color: #ffffff;
        display: block;
        height: 2px;
        margin: 0.325em 0 0.5em 0;
        width: 100%;
        animation: ${slideIn} .6s ease-in-out forwards;
      }
    }
  } 

  .content p {
    font-family: "Montserrat", Helvetica, sans-serif;
    text-transform: uppercase;
    font-weight: 700;
    animation: ${slideIn} .4s ease-in-out forwards;
    font-size: .9em;

    @media (min-width: 1200px) {
      font-size: 1.4em;
    }

  }
`;